import React, {Component} from 'react';
import {aladb, datadb} from 'db'

import {TabsContainer, Tabs, Tab} from 'react-md'

import TabDashboard from 'components/tabs/TabDashboard'
import TabVideo from 'components/tabs/TabVideo'

import css from './Dashboard.module.css'

const stickerIdInsurance = "-Kr_2jirEyJFVFfShggD";
const stickerIdMixed = "-KwQj-KngsfboF9KCwJY";
const stickerIdWorkshop = "-KwVFa336q1Rytl5RlFA";
let timeout = null;

class Dashboard extends Component {
	state = {
		pageTimeout: 600000,
		//pageTimeout: 5000,
		stickerId: null,
		timeout: 10000,
		globalLogsAvailable: false,
		stats: null,
		activeTabIndex: 1,
		rotation: [1, 2, 1, 0],
		step: 0,
		interval: null,
	};

	handleGlobalStatsUpdate = (stats) => this.setState({...this.state, stats});

	handleStickerAccessLogUpdate = (stickerId, stickerLogs) => {
		aladb.createStickerLogTable(stickerId, stickerLogs);

		this.setState({...this.state, stickerId}, () => setTimeout(this.handleTimeout, this.state.timeout));
	};

	handleGlobalAccessLogUpdate = (globalLogs) => {
		aladb.createSummaryLogTable(globalLogs);

		this.setState({...this.state, globalLogsAvailable: true});
	};

	handleTimeout = () => this.setState({...this.state, stickerId: null});

	videoFinished = () => {
		window.clearTimeout(timeout);
		this.nextTab();
		timeout = window.setTimeout(this.nextTab, this.state.pageTimeout);
	};

	componentDidMount() {
		datadb.onGlobalStatsUpdate(this.handleGlobalStatsUpdate);
		datadb.onGlobalAccessLogUpdate(this.handleGlobalAccessLogUpdate);
		datadb.onStickerAccessLogUpdate(stickerIdMixed, this.handleStickerAccessLogUpdate);
		datadb.onStickerAccessLogUpdate(stickerIdInsurance, this.handleStickerAccessLogUpdate);
		datadb.onStickerAccessLogUpdate(stickerIdWorkshop, this.handleStickerAccessLogUpdate);

		timeout = window.setTimeout(this.nextTab, this.state.pageTimeout);
	}

	componentWillUnmount() {
		window.clearTimeout(timeout);
	}

	changeTabIndex = activeTabIndex => this.setState({activeTabIndex});

	nextTab = () => this.setState(state => ({activeTabIndex: state.rotation[(state.step + 1) % 4], step: (state.step + 1) % 4}));

	render() {
		const {stickerId, globalLogsAvailable, stats, activeTabIndex} = this.state;

		return (
			<div className={css.container}>
				<TabsContainer
					colored
					headerZDepth={0}
					activeTabIndex={activeTabIndex}
					onTabChange={this.changeTabIndex}
				>
					<Tabs tabId="sticker-tabs">
						<Tab label="Video" className={css.tab}>
							<TabVideo
								src="http://88.116.26.86/files/ShowroomZeituhr1938VideoNoSoundCompressed.mp4"
								//src="sample.mp4"
								autoPlay={activeTabIndex === 0}
								onNextTab={() => this.changeTabIndex(1)}
								videoFinished={this.videoFinished}
							/>
						</Tab>
						<Tab label="Dashboard" className={css.tab}>
							<TabDashboard
								stickerId={stickerId}
								globalLogsAvailable={globalLogsAvailable}
								stats={stats}
								onPrevTab={() => this.changeTabIndex(0)}
								onNextTab={() => this.changeTabIndex(2)}
							/>
						</Tab>
						<Tab label="Video" className={css.tab}>
							<TabVideo
								src="http://88.116.26.86/files/ShowroomEventStickerNoSoundCompressed.mp4"
								//src="sample.mp4"
								autoPlay={activeTabIndex === 2}
								onPrevTab={() => this.changeTabIndex(1)}
								videoFinished={this.videoFinished}
							/>
						</Tab>
					</Tabs>
				</TabsContainer>
			</div>
		);

		/*return (
			<div>
				<div className="dashboard">
					<div className="dashboard-header">
						{ globalLogsAvailable && stats && <SummaryHeader stats={stats}/> }
					</div>
					<div className="dashboard-body">
						{ stickerId === stickerIdMixed && <StickerMixed /> }
						{ stickerId === stickerIdInsurance && <StickerInsurance /> }
						{ stickerId === stickerIdWorkshop && <StickerWorkshop /> }
						{ !stickerId && globalLogsAvailable && <SummaryBody /> }
					</div>
				</div>
			</div>
		);*/
	}
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard.jsx